module.exports = __webpack_public_path__ + "img/guali.ec96a8b6.ec96a8b6.jpg";